// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '테라젠이텍스',
  targetSheetName: '수수료',
  headerRowIndex: 10,
  headerRowCount: 1,
  dataStartRowIndex: 11,
  columnMapping: {
    drugCode: '품목코드',
    drugName: '제품명',
    price: '약가(원)',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '계열분류',
    '세부계열',
    '성분ㆍ함량',
    '품목코드',
    '제품명',
    '대조약',
    '약가(원)',
    '수수료',
    '비고',
    '생산처',
  ],
});
